export enum SpinnerTypes {
    cloud = 'cloud',
    vkui = 'vkui',
}

export interface IProps {
    type?: SpinnerTypes;
}
